// extracted by mini-css-extract-plugin
module.exports = {"contentLink":"iosAppDevelopment_contentLink__BUDoV"};